<template>
	<div class="container_item">
		<div class="container_item_img">
			<img :src="props.data.hot_ranking_image_path" alt="hot_ranking_image" loading="lazy" />
		</div>
		<div class="container_item_content">
			<span class="content_title">{{ props.data.hot_ranking_name }}</span>
			<div class="content_sub">
				<p>{{ props.data.hot_ranking_description }}</p>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { hotrankingCategorys } from '@/api/hotRanking';

const props = defineProps<{
	data: hotrankingCategorys;
}>();
</script>

<style lang="scss" scoped>
.container_item {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	padding: 1.6rem;
	background-color: var(--color-bg-mid);
	border-radius: var(--border-radius-small);
	cursor: pointer;
	&_img {
		width: 6rem;
		height: 6rem;
		img {
			width: 100%;
			height: 100%;
		}
	}
	&_content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.4rem;
		.content_title {
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-semi-bold);
			line-height: normal;
		}
		.content_sub {
			text-align: center;
			font-size: var(--font-s-small);
			font-weight: var(--font-w-light);
			color: var(--color-base-light);
			line-height: normal;
			// br 태그 숨김
			@media (max-width: 359px) {
				br {
					display: none;
				}
			}
		}
	}
}
</style>
